import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { hideModal } from "../../../redux/actions/modals";
import { selectDoctor } from "../../../redux/actions/select-doctor";
import { State } from "../../../redux/reducers/root";
import { doctorsSelector } from "../../../redux/selectors/doctors";
import { Doctor } from "../../../redux/types";
import { getProfileImageURL } from "../../../utils/image";
import Button from "../button";
import Radio from "../form/radio";
import Waiting from "../waiting";
import ModalTemplate from "./template";

interface Props {}
interface Inputs {
  doctorId: string | number | null | undefined;
}

const SelectDoctorModal: React.FC<Props> = () => {
  const doctors = useSelector(doctorsSelector);
  const selectedDoctor = useSelector((state: State) => state.selectDoctor);
  const { status } = useSelector((state: State) => state.offices);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { handleSubmit, register, setValue } = useForm<Inputs>({
    defaultValues: { doctorId: null },
  });

  useEffect(() => {
    setValue("doctorId", selectedDoctor?.id?.toString());
  }, [selectedDoctor]);

  const onSubmit = async (data: Inputs) => {
    const doctor = doctors.find((i) => i.id === parseInt(data.doctorId as string, 10));
    if (doctor) dispatch(selectDoctor(doctor!));
    const basePathSearch = location.pathname.match(/\/doctors\/\d+\/(\w+)/)!;
    const path = basePathSearch[1];
    history.push(`/doctors/${data.doctorId}/${path}`);
    dispatch(hideModal());
  };

  const renderLabel = (doctor: Doctor) => {
    return (
      <div className="flex items-center">
        <div className="overflow-hidden rounded-full avatar">
          <div className="w-8 h-8">
            <img alt="" src={getProfileImageURL(doctor.pic)} />
          </div>
        </div>
        <div className="mr-3">{doctor.name}</div>
      </div>
    );
  };
  return (
    <ModalTemplate title="انتخاب متخصص" icon="fa fa-user">
      <p className="text-xs leading-8 text-pkc-description-text ">
        برای مشاهده اطلاعات هر متخصص کافیست از میان متخصصان زیر فرد مورد نظر را انتخاب نمایید و و گزینه انتخاب متخصص را
        بزنید
      </p>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <div className="flex flex-col overflow-auto max-h-96">
          {status === "LOADING" ? (
            <Waiting />
          ) : (
            doctors.map((doctor) => (
              <Radio
                key={doctor.id}
                register={register}
                value={doctor.id}
                label={renderLabel(doctor)}
                name="doctorId"
              />
            ))
          )}
        </div>
        <Button className="w-full" type="submit">
          انتخاب متخصص
        </Button>
      </form>
    </ModalTemplate>
  );
};

export default SelectDoctorModal;
